import React, { useEffect, useState } from "react";
import Menusidebar from "../components/Element/Menusidebar";
import CreateIncidentLog from "../components/Element/IncidentLogs/CreateIncidentLogs";
import { isMobileOrLaptop } from "../services/CheckDevice";
import MenuSideBarMobile from "../components/Element/MenuSideBarMobile";

const CreateIncidentLogs = (props) => {
  // Check Device - Start
  const [checkDevice, setCheckDevice] = useState("Mobile");

  window.addEventListener("resize", function () {
    const deviceType = isMobileOrLaptop();
    setCheckDevice(deviceType);
  });

  useEffect(() => {
    const deviceType = isMobileOrLaptop(350);
    setCheckDevice(deviceType);
  }, []);
  // Check Device - End

  return (
    <React.Fragment>
      <div className="page-content bg-white">
        <div className="content-block">
          <div className="section-full bg-white browse-job p-t50 p-b20">
            <div className="container">
              <div className="row">
                {checkDevice == "Mobile" ? (
                  <MenuSideBarMobile page="incident-logs" />
                ) : (
                  <Menusidebar page="incident-logs" />
                )}
                <div className="col-xl-9 col-lg-8 m-b30">
                  <CreateIncidentLog />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CreateIncidentLogs;